import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationService } from '../../../providers/navigation.service';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../providers/api.service';
import { Subscription } from 'rxjs';
import { SM_CONSTANTS } from '../../../shared/constants/sm-constants';
import { ITableColumnHeader } from '../../../models/table-column-header';
import { AddServiceComponent } from 'src/app/shared/components/add-service/add-service.component';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from '../../../providers/shared.service';
import { FormControl } from '@angular/forms';
import { AddServiceTemplateItemComponent } from 'src/app/shared/components/add-service-template-item/add-service-template-item.component';
import { AddServiceTimingsComponent } from 'src/app/shared/components/add-service-timings/add-service-timings.component';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { MessagingService } from 'src/app/providers/messaging.service';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { TranslateService } from '@ngx-translate/core';
import { InvoiceComponent } from 'src/app/shared/components/invoice/invoice.component';
import { CustomerBookingDetailsComponent } from 'src/app/shared/components/customer-booking-details/customer-booking-details.component';
import { InvoiceForReportComponent } from 'src/app/shared/components/invoice-for-report/invoice-for-report.component';
import { InvoiceForFitnessComponent } from 'src/app/shared/components/invoice-for-fitness/invoice-for-fitness.component';
import { InvoiceForReportOnlyComponent } from 'src/app/shared/components/invoice-for-report-only/invoice-for-report-only.component';

@Component({
  selector: 'sm-customer-all-payments',
  templateUrl: './customer-all-payments.component.html',
  styleUrls: ['./customer-all-payments.component.scss']
})
export class CustomerAllPaymentsComponent implements OnInit, OnDestroy {
  entityHashId: string = '';
  phone: string = '';
  countryCode: string = '';
  name: string = '';
  serviceType: string = '';
  public loader: boolean = false;
  serviceTimings: any = []
  customerAllInvoiceLIst: any = []
  serviceList: any[] = [];
  datalength!: number
  public page: number = 1;
  searchString: FormControl = new FormControl('');
  private _apiSubscription: Subscription;
  daysOfWeek = [
    { day: 1, name: 'Sunday' },
    { day: 2, name: 'Monday' },
    { day: 3, name: 'Tuesday' },
    { day: 4, name: 'Wednesday' },
    { day: 5, name: 'Thursday' },
    { day: 6, name: 'Friday' },
    { day: 7, name: 'Saturday' }
  ];

  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: 'date',
      columnProperty: "creation_time"
    },
    {
      columnName: 'invoice no.',
      columnProperty: "inv_no"
    },
    {
      columnName: 'amount',
      columnProperty: "total_price"
    },
    {
      columnName: 'payment due',
      columnProperty: "payment_due"
    },
    {
      columnName: 'Refund status',
      columnProperty: "refund_status"
    },
  
  ];
  
  constructor(private _navService: NavigationService, private route: ActivatedRoute, private _apiService: ApiService, private _modelRef: MatDialog, private sharedService: SharedService, private loaderservice: LoaderServiceService,private messagingService: MessagingService, 
    private angularFireMessaging: AngularFireMessaging,private translateService: TranslateService) { 
    this._navService.hideSidebarAndNav = false;
    // this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
    //   this.ngOnInit();
    // })
    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      // if(resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_PAYMENT_RECORD){
      //   if (resData.result) {

      //     this._apiService.getEntityCustomerBookingHistory(this.entityHashId,this.phone, this.page.toString())
      //   } 
        
      // }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_CUSTOMER_PAYMENT_HISTORY){
        this.customerAllInvoiceLIst = []
        if(resData.result){
          this.customerAllInvoiceLIst = resData.result
          this.customerAllInvoiceLIst.forEach((element:any) => {
            element.creation_time = element.creation_date
            element.payments = typeof element.payments == 'string' ? JSON.parse(element.payments) : element.payments 
            element.refund_status = this.getOverallRefundStatus(element.payments)
          });
            
        }
        this.loaderservice.showLoader = false
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_PAYMENT_RECORD){
        this._apiService.getEntityCustomerPaymentHistory(this.entityHashId,this.countryCode, this.phone,this.mn,this.pageno)
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_INVOICE_PAYMENT_RECORD){
        this._apiService.getEntityCustomerPaymentHistory(this.entityHashId,this.countryCode, this.phone,this.mn,this.pageno)
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_RECORD_FITNESS_INVOICE){
        this._apiService.getEntityCustomerPaymentHistory(this.entityHashId,this.countryCode, this.phone,this.mn,this.pageno)
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_FITNESS_INTERNATIONAL_INVOICE_PAYMENT_RECORD){
        this._apiService.getEntityCustomerPaymentHistory(this.entityHashId,this.countryCode, this.phone,this.mn,this.pageno)
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_DELETE_ENTITY_INVOICE){
        this._apiService.getEntityCustomerPaymentHistory(this.entityHashId,this.countryCode, this.phone,this.mn,this.pageno)
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_DELETE_INTERNATIONAL_INVOICE_DETAILS){
        this._apiService.getEntityCustomerPaymentHistory(this.entityHashId,this.countryCode, this.phone,this.mn,this.pageno)
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_RECORD_FITNESS_INVOICE){
                this._apiService.getEntityCustomerPaymentHistory(this.entityHashId,this.countryCode, this.phone,this.mn,this.pageno)

      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_FITNESS_INTERNATIONAL_INVOICE_PAYMENT_RECORD){
                this._apiService.getEntityCustomerPaymentHistory(this.entityHashId,this.countryCode, this.phone,this.mn,this.pageno)

      }
    })
    
    console.log(this.serviceList);
    if(!localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == 'null'){
      this.messagingService.requestPermission();
    }
    this.translateService.onLangChange.subscribe(() => {
      // Update your column headers when the language changes
      // this.updateColumnHeaders();
    });
  }
  private updateColumnHeaders() {
    this.tableDisplayColumns.forEach((column,index) => {
      let data = [
        "date",
        "amount",
        "status",
        "services",
        "due_amount"
      ]
      
      // Update each column header with the translated value
      column.columnName = this.translateService.instant(`customer_all_bookings.column_headers.${data[index]}`);
    });
  }
  // private modelSubscription: Subscription = new Subscription();
  pageTitle:any = ''
  mHash:any = ''
  mn:any = ''
  pageno:number = 1
  ngOnInit(): void {
    
    // this.loader = true;
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash
      this.phone = data.phone
      this.countryCode = data.code
      this.mHash = data.mHash
      this.mn = data.mn
      this.pageTitle = 'All payments of ' + data.mn
    })
    console.log(this.countryCode);
    

    // if(this.serviceType == '0'){
      this.loaderservice.showLoader = true
      this._apiService.getEntityCustomerPaymentHistory(this.entityHashId,this.countryCode, this.phone,this.mn,this.pageno)
    // }
    // else if(this.serviceType == '1'){
    //   this.loaderservice.showLoader = true
    //   this._apiService.getShopEntityTimeDetails(this.entityHashId)
    // }
    // this.modelSubscription = this._modelRef.afterAllClosed.subscribe((data) => {
    //   this.loader = true;
    //   this._apiService.getServices(this.entityHashId)
    // });

  }
  openInvoice(item:any){

     if(item.appointment_hash){
      this._modelRef.open(InvoiceComponent, {
        width: '510px',
        data: {
          title: 'Invoice',
          ref: this._modelRef,
          data: item.appointment_hash
        },
      });

    }
  }
  viewDetails(item:any){
    // this._modelRef.open(CustomerBookingDetailsComponent, {
    //   width: '700px',
    //   data: {
    //     title: 'Bookings Details',
    //     ref: this._modelRef,
    //     data: item.hash_id,
    //   },
    // });
    if(item.appointment_hash){
      this._modelRef.open(InvoiceComponent, {
        width: '510px',
        data: {
          title: 'Invoice',
          ref: this._modelRef,
          data: item.appointment_hash
        },
      });

    }
    else{
      this._modelRef.open(InvoiceForReportOnlyComponent, {
        width: '510px',
        data: {
          title: 'Invoice',
          ref: this._modelRef,
          data: item.hash_id,
          entityHash: this.entityHashId
        },
      });
    }
  }
  createNotification(title:any, text:any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

  onCreateNewService(){
this._modelRef.open(AddServiceComponent, {
      width: '700px',
      data: {
        title: 'Add service',
        type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
        ref: this._modelRef,
      },
    });
  }
  onCreateNewServiceFromTemplate(){
this._modelRef.open(AddServiceTemplateItemComponent, {
      width: '1000px',
      data: {
        title: 'Add service From Template',
        ref: this._modelRef,
      },
    });
  }

  openAddTime(rowvalue:any){
    rowvalue.serviceType = this.serviceType
    rowvalue.entityHash = this.entityHashId
    this._modelRef.open(AddServiceTimingsComponent, {
      width: '500px',
      data: {
        title: 'Add service timing',
        ref: this._modelRef,
        data: rowvalue
      },
    });
  }

  removeTime(rowvalue:any){
    if(this.serviceType == '0'){
      let data = {
        homeServiceTimeInfo : {
          timeList : [
            {
              hashId: rowvalue.hashId,
              status: 2
            }
          ]
        }
      }
      this._apiService.updateHomeServiceTimeInfo(
        this.entityHashId,
        data
      );
    }
    else if(this.serviceType == '1'){
      let data = {
        entityTimeInfo : {
          timeList : [
            {
              hashId: rowvalue.hashId,
              status: 2
            }
          ]
        }
      }
      this._apiService.updateEntityShopTimeInfo(
        this.entityHashId,
        data
      );
    }
  }

  deactivateService(rowvalue: any){
console.log(rowvalue);
let metadata = {
  serviceTypeInfo: {
    hash_id: rowvalue.hash_id,
    status: 7
  }
}

this._apiService.addUpdateServiceType(metadata, this.entityHashId)

// setTimeout(() => {
//   this.ngOnInit();
// }, 1500);

  }

  activateService(rowvalue:any){
    console.log(rowvalue);
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        status: 1
      }
    }
    
    this._apiService.addUpdateServiceType(metadata, this.entityHashId)
    
    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  deleteService(rowvalue:any){
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        isDelete: 1
      }
    }

    this._apiService.addUpdateServiceType(metadata, this.entityHashId)
    
    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  onEdit(rowvalue:any){
    this._modelRef.open(AddServiceComponent, {
      width: '700px',
      data: {
        title: 'Add service',
        type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
        ref: this._modelRef,
        data: rowvalue,
      },
    });
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    sessionStorage.removeItem('currentSelectedMember')
    // this.clickEventSubscription.unsubscribe();
    // this.modelSubscription.unsubscribe();
  }

  
  onPageChange(ev: any) {
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;
    
    // //this._apiService.getServices(this.entityHashId, this.page.toString())
  }

  firstTimeBelow3:boolean = false;

  searchServiceData(){
    if(this.searchString.value.length >= 3){
      this.firstTimeBelow3 = true
      this.page = 1
      this._apiService.getServiceDataByKeyword(this.entityHashId,this.page, this.searchString.value)
    }
    else{
      if (this.firstTimeBelow3) {
      this.firstTimeBelow3 = false
      this.page = 1
      // //this._apiService.getServices(this.entityHashId, this.page.toString())
      }
    }
  }

  reset(){
    this.searchString.reset()
    this.page = 1
    // //this._apiService.getServices(this.entityHashId, this.page.toString())
  }

  convertTo12HourFormat(timeString:any) {
    
    const [hours, minutes] = timeString.split(':');
    let period = 'AM';
    let hour = parseInt(hours, 10);
  
    if (hour >= 12) {
      period = 'PM';
      if (hour > 12) {
        hour -= 12;
      }
    }
  
    return `${hour.toString().padStart(2, '0')}:${minutes} ${period}`;
  }
// NEW CODE FOR ROW CLICK
 rowClickHandler = (row: any) => {
  this.viewDetails(row);
};


getOverallRefundStatus(payments:any) {
  if (!Array.isArray(payments) || payments.length === 0) {
    return '---';
  }

  const statuses = payments.map(p => Number(p.refund_status));

  if (statuses.includes(3)) {
    return 'Refund Failed';
  }

  if (statuses.includes(1)) {
    return 'Refund Initiated';
  }

  if (statuses.every(s => s === 2)) {
    return 'Refund Complete';
  }

  return '---';
}


}

